document.addEventListener("DOMContentLoaded", function () {
  function renderIconSlideshows() {
    document
      .querySelectorAll(".icon-slideshow")
      .forEach(function (iconSlideshow) {
        var container = iconSlideshow.querySelector(".slideshow-container");
        if (!container) return;
        // 清理旧class和箭头
        container.classList.remove("container");
        var carouselInner = container.querySelector(
          ".icon-slideshow-carousel-inner"
        );
        if (!carouselInner) return;
        carouselInner.classList.remove("mobile-slideshow-grid");
        carouselInner.classList.remove("icon-slideshow-grid");
        carouselInner.classList.remove("icon-slideshow-scrollable");
        // 清理旧箭头
        var arrowsWrap = container.querySelector(".icon-slideshow-arrows");
        if (arrowsWrap) arrowsWrap.innerHTML = "";

        // 新增：重置滚动和卡片状态
        carouselInner.scrollLeft = 0;
        var allCards = carouselInner.querySelectorAll(".as-carousel-item");
        allCards.forEach(function (card) {
          card.classList.remove("outside");
          card.style.opacity = "";
          card.style.transform = "";
          card.style.zIndex = "";
        });

        var enableSider = container.querySelector(".enable-sider") !== null;
        var cards = carouselInner.querySelectorAll(".as-carousel-item");
        var count = cards.length;
        const isMobile =
          window.innerWidth < 768 || document.documentElement.clientWidth < 768;
        if (isMobile) {
          if (!enableSider) {
            container.classList.add("container");
            carouselInner.classList.add("mobile-slideshow-grid");
            return;
          }
        }
        if (count <= 4) {
          container.classList.add("container");
          return;
        }
        if (count > 4 && !enableSider) {
          container.classList.add("container");
          carouselInner.classList.add("icon-slideshow-grid");
          return;
        }
        carouselInner.classList.add("icon-slideshow-scrollable");
        var carousel = container.querySelector(
          ".icon-slideshow-carousel-inner.icon-slideshow-scrollable"
        );
        var arrowsWrap = container.querySelector(".icon-slideshow-arrows");
        if (!carousel || !arrowsWrap) return;
        if (arrowsWrap) arrowsWrap.style.display = "";
        // 先清空箭头容器，防止重复插入
        arrowsWrap.innerHTML = "";

        // 动态获取卡片宽度+间隙
        function getCardWidthWithGap(list) {
          var card = list.querySelector(".as-carousel-item");
          if (!card) return 0;
          var style = window.getComputedStyle(card);
          var cardWidth = card.getBoundingClientRect().width;
          // 尝试获取 margin-right
          var gap = parseFloat(style.marginRight) || 0;
          // 如果你用的是 grid/flex 的 gap，可以用父容器的 column-gap
          var parentGap =
            parseFloat(window.getComputedStyle(list).columnGap) || 0;
          // 取最大值（实际布局哪个有用取哪个）
          return cardWidth + Math.max(gap, parentGap);
        }
        // 动态获取每页可见卡片数
        function getPerPage(list) {
          var listRect = list.getBoundingClientRect();
          var style = getComputedStyle(list);
          var paddingLeft = parseFloat(style.paddingLeft);
          var paddingRight = parseFloat(style.paddingRight);
          var cardWidth = getCardWidthWithGap(list);
          var parentGap = parseFloat(style.columnGap) || 0;
          if (!cardWidth) return 1;
          return Math.floor(
            (listRect.width - paddingLeft - paddingRight + parentGap + 1) /
              cardWidth
          );
        }

        // 箭头按钮
        var leftBtn = document.createElement("button");
        leftBtn.className = "icon-slideshow-arrow";
        leftBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/>
</svg>
`;
        leftBtn.disabled = true;
        var rightBtn = document.createElement("button");
        rightBtn.className = "icon-slideshow-arrow";
        rightBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/>
</svg>
`;
        arrowsWrap.appendChild(leftBtn);
        arrowsWrap.appendChild(rightBtn);

        carousel._currentIndex = 0;

        function updateCards() {
          var currentIndex = carousel._currentIndex || 0;
          var perPage = getPerPage(carousel);
          var cardWidth = getCardWidthWithGap(carousel);
          var maxIndex = Math.max(0, count - perPage);
          var centerStart = currentIndex;
          var centerEnd = centerStart + perPage;
          cards.forEach(function (card, idx) {
            if (idx >= centerStart && idx < centerEnd) {
              card.classList.remove("outside");
            } else {
              card.classList.add("outside");
            }
          });
          leftBtn.disabled = currentIndex === 0;
          rightBtn.disabled = currentIndex >= maxIndex;
          // leftBtn.innerHTML = leftBtn.disabled ? "<" : "<";
          // rightBtn.innerHTML = rightBtn.disabled ? ">" : ">";
          if (currentIndex >= maxIndex) {
            carousel.classList.add("at-end");
          } else {
            carousel.classList.remove("at-end");
          }
        }
        carousel._updateCards = updateCards;

        function scrollToIndex(idx) {
          var cardWidthWithGap = getCardWidthWithGap(carousel);
          var maxIndex = Math.max(0, count - 1); // 只要不超出最后一个
          var targetIdx = Math.min(idx, maxIndex);
          carousel._currentIndex = targetIdx;
          var scrollLeft = targetIdx * cardWidthWithGap;
          carousel.scrollTo({ left: scrollLeft, behavior: "smooth" });
          updateCards();
        }

        leftBtn.addEventListener("click", function () {
          if ((carousel._currentIndex || 0) > 0)
            scrollToIndex((carousel._currentIndex || 0) - 1);
        });
        rightBtn.addEventListener("click", function () {
          if ((carousel._currentIndex || 0) < count - 1)
            scrollToIndex((carousel._currentIndex || 0) + 1);
        });

        // hover效果：鼠标移入透明卡片时，透明度100%且放大
        cards.forEach(function (card) {
          card.addEventListener("mouseenter", function () {
            if (card.classList.contains("outside")) {
              card.style.opacity = "1";
              card.style.zIndex = "2";
            }
          });
          card.addEventListener("mouseleave", function () {
            if (card.classList.contains("outside")) {
              card.style.opacity = "";
              card.style.transform = "";
              card.style.zIndex = "";
            }
          });
        });

        // 初始化
        updateCards();
        setTimeout(updateCards, 50);
        // 图片加载后再刷新一次
        var img = carousel.querySelector("img");
        if (img) {
          img.addEventListener("load", function () {
            updateCards();
          });
        }

        // 新增：监听滚动事件，实时更新按钮和卡片状态
        carousel.addEventListener("scroll", function () {
          var cardWidth = getCardWidthWithGap(carousel);
          if (!cardWidth) return;
          var newIndex = Math.round(carousel.scrollLeft / cardWidth);
          if (carousel._currentIndex !== newIndex) {
            carousel._currentIndex = newIndex;
            if (typeof carousel._updateCards === "function") {
              carousel._updateCards();
            }
          }
        });

        // 动态设置滚动区两侧padding，保证内容居中且最大宽度不超过1200px
        function setSlideshowSidePadding() {
          var maxContentWidth = 1200;
          var winWidth = document.documentElement.clientWidth;
          var sidePadding =
            (winWidth - Math.min(winWidth, maxContentWidth)) / 2;
          if (sidePadding < 40) sidePadding = 24;
          carousel.style.setProperty(
            "--icon-slideshow-side-padding",
            sidePadding + "px"
          );
        }
        window.addEventListener("resize", setSlideshowSidePadding);
        setSlideshowSidePadding();
      });
  }
  renderIconSlideshows();
  window.addEventListener("resize", renderIconSlideshows);
});
